import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, catchError, switchMap, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { AuthTokenService } from '../services/auth-token.service';

export function authInterceptor(
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
  const tokenStore = inject(AuthTokenService);
  const authService = inject(AuthService);

  if (request.headers.has('X-Skip-Auth')) {
    return next(request);
  }

  const accessToken = tokenStore.getAccessToken();
  const authRequest = accessToken
    ? request.clone({ setHeaders: { Authorization: `Bearer ${accessToken}` } })
    : request;

  return next(authRequest).pipe(
    catchError((error: HttpErrorResponse) => {
      if (
        error.status !== 401 ||
        request.url.includes('/api/auth/refresh') ||
        request.url.includes('/api/auth/admin/')
      ) {
        return throwError(() => error);
      }

      return authService.refreshTokens().pipe(
        switchMap((tokens) => {
          const retryRequest = request.clone({
            setHeaders: { Authorization: `Bearer ${tokens.accessToken}` }
          });
          return next(retryRequest);
        }),
        catchError((refreshError) => {
          tokenStore.clear();
          return throwError(() => refreshError);
        })
      );
    })
  );
}
